import Vue from "vue";
import Vuex from "vuex";
import { getUserInfo } from "@/api/admin";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {},
    userOrgList: [],
    userRootList: [], //用户当前能查看的通讯录组织
  },
  getters: {
    userInfo: ({ userInfo }) => userInfo,
    userOrgList: ({ userOrgList }) => userOrgList,
  },
  mutations: {
    SET_USER_INFO(state, payload) {
      state.userInfo = payload;
    },
    SET_USER_ORG_LIST(state, payload) {
      state.userOrgList = payload;
    },
    SET_USER_ROOT_LIST(state, payload) {
      state.userRootList = payload;
    },
  },
  actions: {
    setUserInfo() {
      return new Promise((resolve, reject) => {
        getUserInfo({})
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  modules: {},
});
